import { Button, Modal } from "antd";
import { useCallback } from "react";

const ConfirmationModal = ({
  isModalOpen,
  setIsModalOpen,
  handleOk,
  handleCancel,
  children,
  title,
  okText = "OK",
  okButtonProps = {},
}) => {
  const okHandler = useCallback(() => {
    handleOk();
    setIsModalOpen(false);
  }, [handleOk]);

  const cancelHandler = useCallback(() => {
    if (handleCancel) {
      handleCancel();
    }
    setIsModalOpen(false);
  }, [handleCancel]);

  return (
    <>
      <Modal
        title={title}
        open={isModalOpen}
        onCancel={cancelHandler}
        footer={[
          <Button key="submit" type="primary" onClick={okHandler} {...okButtonProps}>
            {okText}
          </Button>,
          <Button key="back" onClick={cancelHandler}>
            Cancel
          </Button>,
        ]}
      >
        {children}
      </Modal>
    </>
  );
};

export default ConfirmationModal;
